import { render, staticRenderFns } from "./DistributionDocumentDropoffForm.vue?vue&type=template&id=7d89cd9e"
import script from "./DistributionDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./DistributionDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports